import { Page, Text, View, Document, StyleSheet, Font, Image } from "@react-pdf/renderer";
import persianFont from "../../../../assets/fonts/YekanBakh/woff/YekanBakh-Regular.woff";
import { convertToJalali, formatPersianDate } from "../../../../utils/date";
import { numberWithCommas } from "../../../../utils/utility";

import logoImage from "../../../../assets/imgs/green logo.png";
import airArrowRight from "../../../../assets/icons/arrow-right-bold.png";
import airArrowLeft from "../../../../assets/icons/arrow-left-bold.png";

const FlightPdf = ({ orderItem }) => {
    function FlightDetailsContent({ uniqueId, details, passenger }) {
        const passengerType = passenger.type.toUpperCase();
        return (
            <>
                {uniqueId && (
                    <div style={[styles.displayRow, styles.columnGap]}>
                        <div style={[styles.displayRow, styles.columnGap]}>
                            <Text style={styles.text}>:po</Text>
                            <Text style={styles.boldText}>{uniqueId}</Text>
                        </div>
                        <div style={[styles.displayRow, styles.columnGap]}>
                            <Text style={styles.text}>:شماره بلیط</Text>
                            {details?.passengers?.map(p => {
                                if (
                                    p?.birthdate == passenger?.birthdate &&
                                    p?.english_first_name == passenger?.english_first_name &&
                                    p?.english_last_name == passenger?.english_last_name &&
                                    p?.type == passenger?.type
                                ) {
                                    return <Text style={styles.boldText}>{p?.tickets?.[0]?.ticket_number}</Text>;
                                }
                            })}
                        </div>
                    </div>
                )}

                <div style={[styles.displayRow, styles.spaceBetween, styles.segment]}>
                    <div style={[styles.displayRow, styles.columnGap]}>
                        <Text style={styles.boldText}>{details?.domestic_departure}</Text>
                        <Text style={styles.text}>به</Text>
                        <Text style={styles.boldText}>{details?.domestic_destination}</Text>
                    </div>
                    {details.tag === "pr" && (
                        <>
                            <div style={[styles.displayRow, styles.columnGap]}>
                                <Text style={styles.boldText}>
                                    ({details?.departure?.terminal?.code}) {details?.departure?.terminal?.name}{" "}
                                </Text>
                                <Text style={styles.text}>به</Text>
                                <Text style={styles.boldText}>
                                    ({details?.destination?.terminal?.code}) {details?.destination?.terminal?.name}{" "}
                                </Text>
                            </div>
                            <div style={[styles.displayRow, styles.columnGap]}>
                                <Text style={styles.boldText}>:ترمینال حرکت {details?.departure_terminal}</Text>
                                <Text style={styles.boldText}>:ترمینال ورود {details?.destination_terminal}</Text>
                            </div>
                        </>
                    )}
                </div>
                <div style={[styles.displayRow, styles.columnGap, styles.segment]}>
                    <Text style={styles.text}>
                        {details?.departure_time?.split(":", 2).join(":")} , تاریخ و ساعت حرکت:{" "}
                        {formatPersianDate(details?.departure_date, {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                            weekday: "long",
                        })}{" "}
                    </Text>
                    <Text style={styles.text}>
                        {details?.destination_time?.split(":", 2).join(":")} ,{" "}
                        تاریخ و ساعت ورود: {" "}
                        {formatPersianDate(details?.arrival_date, {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                            weekday: "long",
                        })}{" "}
                    </Text>
                </div>
                <div style={[styles.displayRow, styles.spaceBetween]}>
                    <div style={[styles.displayRow, styles.columnGap]}>
                        {/* <Image src={convertToBase64(airlineIcon)} style={styles.arrowIcon} /> */}
                        <Image src={orderItem?.flight?.segments[0]?.airline?.image} style={styles.arrowIcon} />
                        <Text style={styles.text}>هواپیمایی</Text>
                        <Text style={styles.boldText}>{details?.airline.english}</Text>
                    </div>
                    <div style={[styles.displayRow, styles.columnGap]}>
                        <Text style={[styles.boldText, styles.label]}>{details?.flight_number} :شماره پرواز</Text>
                        <Text style={[styles.boldText, styles.label]}>{details?.airline.aircraft}</Text>
                        <Text style={[styles.boldText, styles.label]}>{details?.cobin_name}</Text>
                        <Text style={[styles.boldText, styles.label]}>{details?.type}</Text>
                        {passengerType !== "INF" ? <Text style={[styles.boldText, styles.label]}>{details?.baggage} :بار مجاز</Text> : ""}
                    </div>
                </div>
            </>
        );
    }
    Font.register({
        family: "iranSans",
        src: persianFont,
    });
    const styles = StyleSheet.create({
        page: {
            direction: "rtl",
            rowGap: 10,
            padding: "8px 20px",
            fontFamily: "iranSans",
        },
        displayRow: {
            flexDirection: "row-reverse",
            alignItems: "center",
            columnGap: 2,
        },
        spaceBetween: {
            justifyContent: "space-between",
        },
        columnGap: {
            columnGap: 10,
        },
        displayColumn: {
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-end",
        },
        section: {
            rowGap: 5,
        },
        logoImage: {
            width: 135,
            height: 30,
        },
        logoText: {
            color: "#006363",
            fontSize: 5,
            fontWeight: 700,
        },
        text: {
            fontSize: 8,
        },
        boldText: {
            fontSize: 8,
            fontWeight: 700,
        },
        title: {
            flexDirection: "row-reverse",
            padding: "2px 8px",
            backgroundColor: "#E6EBF0",
        },
        flightTitle: {
            flexDirection: "row-reverse",
            alignItems: "center",
            columnGap: 2,
            padding: "2px 16px",
            color: "#FFFFFF",
            backgroundColor: "#006363",
            fontSize: 8,
        },
        arrowIcon: {
            width: 5,
            height: 5,
        },
        segment: {
            padding: "2px 8px",
            backgroundColor: "#F7F7F7",
        },
        label: {
            padding: "2px 8px",
            border: "1px solid #808080",
            borderRadius: "10px",
        },
        price: {
            padding: "2px 8px",
            borderBottom: "1px solid #F0F0F0",
        },
        note: {
            color: "red",
        },
    });

    const ageType = {
        adt: "بزرگسال",
        chd: "کودک",
        inf: "نوزاد",
        ADT: "بزرگسال",
        ADL: "بزرگسال",
        CHD: "کودک",
        INF: "نوزاد",
    };

    return (
        <Document>
            {orderItem?.flight?.segments[0]?.passengers?.map(passenger => {
                return (
                    <Page key={Math.random()} size="A4" style={styles.page}>
                        <View style={[styles.displayRow, styles.spaceBetween]}>
                            <div style={styles.displayColumn}>
                                <Image src={logoImage} style={styles.logoImage} />
                            </div>
                            <Text style={styles.boldText}>بلیط سفر</Text>
                            <div>
                                <div style={[styles.displayRow, styles.spaceBetween]}>
                                    <Text style={styles.text}>پشتیبانی:</Text>
                                    <Text style={styles.boldText}>{`${"09961650417"}`}</Text>
                                </div>
                                <div style={[styles.displayRow, styles.spaceBetween]}>
                                    <Text style={styles.text}> شماره پیگیری:</Text>
                                    <Text style={styles.boldText}>{`${orderItem?.tracking_code}`}</Text>
                                </div>
                                <div style={[styles.displayRow, styles.spaceBetween]}>
                                    <Text style={styles.text}> تاریخ صدور بلیط:</Text>
                                    <Text style={styles.boldText}>{`${convertToJalali(orderItem?.create_date)}`}</Text>
                                </div>
                            </div>
                        </View>

                        <View style={styles.section}>
                            <div style={styles.title}>
                                <Text style={styles.boldText}>مشخصات مسافر</Text>
                            </div>
                            <div>
                                <div style={[styles.displayRow, styles.columnGap]}>
                                    <Text style={styles.text}>:نام مسافر</Text>
                                    <Text style={styles.boldText}>
                                        {passenger?.last_name} {passenger?.first_name}
                                    </Text>
                                    <Text style={styles.boldText}>
                                        {passenger?.english_first_name} {passenger?.english_last_name}
                                    </Text>
                                </div>
                                <div style={[styles.displayRow, styles.columnGap]}>
                                    <div style={[styles.displayRow, styles.spaceBetween]}>
                                        <Text style={styles.text}>:رده سنی</Text>
                                        <Text style={styles.boldText}>{ageType[passenger?.type]}</Text>
                                    </div>
                                    {!!passenger?.national_id ? (
                                        <div style={[styles.displayRow, styles.spaceBetween]}>
                                            <Text style={styles.text}>:کد ملی</Text>
                                            <Text style={styles.boldText}>{passenger?.national_id}</Text>
                                        </div>
                                    ) : null}
                                    {!!passenger?.passport_number ? (
                                        <div style={[styles.displayRow, styles.spaceBetween]}>
                                            <Text style={styles.text}>:شماره پاسپورت</Text>
                                            <Text style={styles.boldText}>{passenger?.passport_number}</Text>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </View>

                        <View style={styles.section}>
                            <div style={styles.title}>
                                <Text style={styles.boldText}>جزئیات پرواز</Text>
                            </div>

                            <div style={styles.displayRow}>
                                <div style={styles.flightTitle}>
                                    <Image src={airArrowRight} style={styles.arrowIcon} />
                                    <Text>پرواز رفت</Text>

                                    <Text style={styles.text}>({`${orderItem?.flight?.segments[0]?.airline_pnr} :Airline PNR`})</Text>
                                </div>
                            </div>
                            {orderItem.flight.segments.map(segment => {
                                return <FlightDetailsContent uniqueId={orderItem?.flight?.unique_id} details={segment} passenger={passenger} />;
                            })}

                            {orderItem?.flight?.return_segments?.length ? (
                                <div style={styles.displayRow}>
                                    <div style={styles.flightTitle}>
                                        <Image src={airArrowLeft} style={styles.arrowIcon} />
                                        <Text>پرواز برگشت</Text>

                                        <Text style={styles.text}>({`${orderItem?.flight?.return_segments[0]?.airline_pnr} :َAirline PNR`})</Text>
                                    </div>
                                </div>
                            ) : null}
                            {orderItem?.flight?.return_segments?.map(segment => {
                                return (
                                    <FlightDetailsContent uniqueId={orderItem?.flight?.return_unique_id} details={segment} passenger={passenger} />
                                );
                            })}
                        </View>

                        <View style={styles.section}>
                            {orderItem?.flight?.notes?.map(note => {
                                return <Text style={[styles.boldText, styles.note]}>{note?.note}</Text>;
                            })}
                        </View>

                        <View style={styles.section}>
                            <div style={styles.title}>
                                <Text style={styles.boldText}>جزئیات قیمت</Text>
                            </div>

                            <div style={[styles.displayRow, styles.spaceBetween, styles.price]}>
                                <Text style={styles.boldText}>:قیمت کل</Text>
                                <Text style={styles.boldText}>
                                    ریال{" "}
                                    {numberWithCommas(
                                        (() => {
                                            const matchPassenger = p =>
                                                p?.birthdate === passenger?.birthdate &&
                                                p?.english_first_name === passenger?.english_first_name &&
                                                p?.english_last_name === passenger?.english_last_name &&
                                                p?.type === passenger?.type;

                                            const departPrice = orderItem?.flight?.segments[0]?.passengers?.find(matchPassenger)?.total_price || 0;

                                            const returnPrice =
                                                orderItem?.flight?.return_segments[0]?.passengers?.find(matchPassenger)?.total_price || 0;

                                            return departPrice + returnPrice;
                                        })(),
                                    )}
                                </Text>
                            </div>
                        </View>
                        <View style={styles.section}>
                            <div style={styles.title}>
                                <Text style={styles.boldText}>قوانین و مقررات</Text>
                            </div>

                            <div style={[styles.displayRow, styles.spaceBetween, styles.price]}>
                                <Text style={styles.text}>.هزینه های کنسلی طبق قوانین ایرلاین محاسبه میگردد</Text>
                            </div>
                            <div style={[styles.displayRow, styles.spaceBetween, styles.price]}>
                                <Text style={styles.text}>.مسافر گرامی، شما میبایستی 2 ساعت قبل از زمان پرواز در فرودگاه حضور داشته باشید</Text>
                            </div>
                            <div style={[styles.displayRow, styles.spaceBetween, styles.price]}>
                                <Text style={styles.text}>
                                    .در صورت ایجاد هرگونه محدودیت در پذیرش مسافر، این شرکت هیچگونه مسئولیتی در این خصوص نخواهد داشت و کلیه خسارات
                                    متوجه خریدار میباشد
                                </Text>
                            </div>
                        </View>
                    </Page>
                );
            })}
        </Document>
    );
};

export default FlightPdf;
